import { getUrlSearchParams } from '../getUrlSearchParams/getUrlSearchParams.util';

export const getQueryParam = (key: string): string | null => {
  const urlSearchParams: URLSearchParams | null = getUrlSearchParams();
  if (urlSearchParams) {
    const queryParamWithKey: string | null = urlSearchParams.get(key);
    return queryParamWithKey || '';
  } else {
    return null;
  }
};
